// removed by extract-text-webpack-plugin
module.exports = {"background-overlay":"doctify-modal_background-overlay--l-15k2IN","backgroundOverlay":"doctify-modal_background-overlay--l-15k2IN","modal-container":"doctify-modal_modal-container--2Jc0Ul9C","modalContainer":"doctify-modal_modal-container--2Jc0Ul9C","header":"doctify-modal_header--16-_3uLF","title":"doctify-modal_title--1Q-mMyu1","close":"doctify-modal_close--1HSCdQzi"};


//////////////////
// WEBPACK FOOTER
// ./components/doctify-modals/src/styles/doctify-modal.scss
// module id = 1644
// module chunks = 0